import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

const heroMovies = movies.filter((m) => m.isHot).slice(0, 3);

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % heroMovies.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  const movie = heroMovies[currentSlide];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center transition-all duration-700"
        style={{ backgroundImage: `url(${movie.backdropUrl})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80" />

      <div className="absolute bottom-0 left-0 right-0 z-10">
        <div className="w-full px-4 md:px-6 pb-16 md:pb-20">
          <div className="flex flex-col items-start max-w-2xl">
            <div className="flex items-center gap-3 mb-3">
              {movie.isNew && (
                <span className="px-2.5 py-1 text-xs font-medium bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
                  最新上映
                </span>
              )}
              <span className="px-2.5 py-1 text-xs font-medium bg-background-50/20 text-background-50 rounded-full whitespace-nowrap">
                {movie.category}
              </span>
              <span className="text-sm text-background-50/80">{movie.year}</span>
            </div>

            <h1 className="text-2xl md:text-4xl font-bold text-background-50 mb-3 font-[var(--font-heading)]">
              {movie.title}
            </h1>
            <p className="text-sm md:text-base text-background-50/70 mb-5 max-w-xl leading-relaxed">
              {movie.description}
            </p>

            <div className="flex items-center gap-3 flex-wrap">
              <Link
                to={`/article/${movie.id}`}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent-500 text-background-50 rounded-full text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观看
              </Link>
              <Link
                to={`/article/${movie.id}`}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50/15 text-background-50 rounded-full text-sm font-medium hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line text-lg"></i>
                影片详情
              </Link>
            </div>
          </div>

          <div className="flex items-center gap-4 mt-8">
            <div className="flex items-center gap-1.5">
              {heroMovies.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setCurrentSlide(idx)}
                  className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                    idx === currentSlide
                      ? 'w-6 bg-accent-500'
                      : 'bg-background-50/40 hover:bg-background-50/60'
                  }`}
                  aria-label={`切换到第${idx + 1}张`}
                />
              ))}
            </div>
            <span className="text-xs text-background-50/50">
              {currentSlide + 1} / {heroMovies.length}
            </span>
          </div>
        </div>
      </div>

      <button
        onClick={() => setCurrentSlide((prev) => (prev - 1 + heroMovies.length) % heroMovies.length)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-10 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-background-50/15 hover:bg-background-50/25 text-background-50 rounded-full transition-colors cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-10 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-background-50/15 hover:bg-background-50/25 text-background-50 rounded-full transition-colors cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </section>
  );
}